define(['jquery', 'globalVars', 'matchSize'], (
    $,
    { $body, $window },
    matchSize
) => {
    return {
        init() {
            if (!matchSize().mobile) {
                return;
            }

            const $btn = $('.js-fixed-bnt').first();
            const $parentBtn = $btn.parent();

            if ($parentBtn.length) {
                const parentOffset =
                    $parentBtn.offset().top + $parentBtn.innerHeight();

                $window.on('scroll', () => {
                    $window.scrollTop() + $window.innerHeight() > parentOffset
                        ? $btn.removeClass('_fixed')
                        : $btn.addClass('_fixed');
                });
            }
        },
    };
});
